var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.8974 2.5H6.26406C3.38906 2.5 1.66406 4.21667 1.66406 7.1V13.725C1.66406 16.6167 3.38906 18.3333 6.26406 18.3333H12.8891C15.7724 18.3333 17.4891 16.6167 17.4891 13.7333V7.1C17.4974 4.21667 15.7724 2.5 12.8974 2.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5143 2.48324C16.0226 0.983238 14.5643 0.949904 13.031 2.48324L12.0893 3.41657C12.006 3.4999 11.981 3.61657 12.0143 3.7249C12.5976 5.76657 14.231 7.3999 16.2726 7.98324C16.2976 7.99157 16.3393 7.99157 16.3643 7.99157C16.4476 7.99157 16.531 7.95824 16.5893 7.8999L17.5143 6.96657C18.2726 6.20824 18.6476 5.48324 18.6476 4.74157C18.6476 3.99157 18.2726 3.2499 17.5143 2.48324Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8816 8.68353C14.6566 8.57519 14.44 8.46686 14.24 8.34186C14.0733 8.24186 13.9066 8.13353 13.7483 8.01686C13.615 7.93353 13.465 7.80853 13.315 7.68353C13.2983 7.6752 13.2483 7.63353 13.1816 7.56686C12.9233 7.35853 12.6483 7.07519 12.39 6.76686C12.3733 6.75019 12.3233 6.70019 12.2816 6.62519C12.1983 6.53353 12.0733 6.3752 11.965 6.2002C11.8733 6.08353 11.765 5.91686 11.665 5.74186C11.54 5.53353 11.4316 5.3252 11.3316 5.10853C11.2233 4.8752 11.14 4.65853 11.065 4.4502L6.58163 8.93353C6.28996 9.22519 6.00663 9.7752 5.94829 10.1835L5.58996 12.6669C5.51496 13.1919 5.65663 13.6835 5.98163 14.0085C6.25663 14.2835 6.63163 14.4252 7.04829 14.4252C7.13996 14.4252 7.23163 14.4169 7.32329 14.4085L9.79829 14.0585C10.2066 14.0002 10.7566 13.7252 11.0483 13.4252L15.5316 8.94186C15.3233 8.87519 15.115 8.78353 14.8816 8.68353Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPencil);
export default __webpack_public_path__ + "static/media/icon_edit_pencil.12faabd36075a9ae7d8a500d7e88f57a.svg";
export { ForwardRef as ReactComponent };